<template>
  <div id="app">
    <router-view></router-view> 
  </div>
</template>

<script>


export default {
  name: "App",
  components: {
    
  },
  data() {
    return {}
  }    
};


</script>
<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #444;
    /*margin-top: 60px; */
    background-color: #ffffff !important;
    max-width: 100vw !important;
    margin: 0px;
  }

  html, body {
      overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue